export default function dec2hex(dec: number): string {
  return `0x${dec.toString(16)}`;
}
